import axiosTuri from "../../axiosTuri";

// Get All Lead Status
export const get_lead_status = async () => {
  const res = await axiosTuri.get(`get-all-lead-status`);
  if (res.data.status == "success") {
    return res.data.data;
  }
};

// Get All Cooperators
export const get_cooperators = async () => {
  const res = await axiosTuri.get(`get-all-cooperators`);
  if (res.data.status == "success") {
    return res.data.data;
  }
};

// Create Lead Status
export const create_lead_status = async (data) => {
  const res = await axiosTuri.post(`create-lead-status`, data);
  if (res.data.status == "success") {
    return res.data;
  }
};

// Edit Lead Status
export const edit_lead_status = async (data) => {
  const res = await axiosTuri.post(`edit-lead-status/${data.id}`, data.data);
  if (res.data.status == "success") {
    return res.data;
  }
};

// Delete Lead Status
export const delete_lead_status = async (id) => {
  const res = await axiosTuri.delete(`delete-lead-status/${id}`);
  if (res.data.status == "success") {
    return res.data;
  }
};

// Get All Campaigns
export const get_all_campaigns = async () => {
  const res = await axiosTuri.get(`get-all-campaigns`);
  if (res.data.status == "success") {
    return res.data.data;
  }
};

// Create New Campaign
export const create_campaign = async (data) => {
  const res = await axiosTuri.post(`create-campaign`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  if (res.data.status == "success") {
    return res.data;
  }
};

// Edit Campaign
export const edit_campaign = async (data) => {
  const res = await axiosTuri.post(`edit-campaign/${data.id}`, data.data);
  if (res.data.status == "success") {
    return res.data;
  }
};

// Delete Campaign
export const delete_campaign = async (id) => {
  const res = await axiosTuri.delete(`delete-campaign/${id}`);
  if (res.data.status == "success") {
    return res.data;
  }
};

// Add Campaign Docoments
export const add_campaign_docoments = async (data) => {
  const res = await axiosTuri.post(`add-campaign-docoments`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  if (res.data.status == "success") {
    return res.data;
  }
};

// Delete Campaign docoment
export const delete_campaign_docoment = async (id) => {
  const res = await axiosTuri.delete(`delete-campaign-docoment/${id}`);
  if (res.data.status == "success") {
    return res.data;
  }
};

// Get All Requests
export const get_requests = async () => {
  const res = await axiosTuri.get(`get-all-requests`);
  if (res.data.status == "success") {
    return res.data.data;
  }
};

// Get All Leads
export const get_leads = async () => {
  const res = await axiosTuri.get(`get-all-leads`);
  if (res.data.status == "success") {
    return res.data.data;
  }
};

// Get All Leads Archive
export const get_leads_archive = async () => {
  const res = await axiosTuri.get(`get-all-leads-archive`);
  if (res.data.status == "success") {
    return res.data.data;
  }
};

// Create Lead
export const create_lead = async (data) => {
  const res = await axiosTuri.post(`create-lead`, data);
  if (res.data.status == "success") {
    return res.data;
  }
};

// Edit Lead
export const edit_lead = async (data) => {
  const res = await axiosTuri.post(`edit-lead/${data.id}`, data.data);
  if (res.data.status == "success") {
    return res.data;
  }
};

// Delete Lead
export const delete_lead = async (id) => {
  const res = await axiosTuri.delete(`delete-lead/${id}`);
  if (res.data.status == "success") {
    return res.data;
  }
};

// Get All Travel Agencies
export const get_all_travel_agencies = async () => {
  const res = await axiosTuri.get(`get-all-travel-agencies`);
  if (res.data.status == "success") {
    return res.data.data;
  }
};

// Create New Travel Agency
export const create_travel_agency = async (data) => {
  const res = await axiosTuri.post(`create-travel-agency`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  if (res.data.status == "success") {
    return res.data;
  }
};

// Edit Travel Agency
export const edit_travel_agency = async (data) => {
  const res = await axiosTuri.post(`edit-travel-agency/${data.id}`, data.data);
  if (res.data.status == "success") {
    return res.data;
  }
};

// Delete Travel agency
export const delete_travel_agency = async (id) => {
  const res = await axiosTuri.delete(`delete-travel-agency/${id}`);
  if (res.data.status == "success") {
    return res.data;
  }
};

// Add Travel Agency Documents
export const add_travel_agency_documents = async (data) => {
  const res = await axiosTuri.post(`add-travel-agenc-documents`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  if (res.data.status == "success") {
    return res.data;
  }
};

// Delete Travel Agency document
export const delete_travel_agency_document = async (id) => {
  const res = await axiosTuri.delete(`delete-travel-agency-document/${id}`);
  if (res.data.status == "success") {
    return res.data;
  }
};

// Get All Cold Campaigns
export const get_all_cold_campaigns = async () => {
  const res = await axiosTuri.get(`get-all-cold-campaigns`);
  if (res.data.status == "success") {
    return res.data.data;
  }
};

// Create New cold Campaign
export const create_cold_campaign = async (data) => {
  const res = await axiosTuri.post(`create-cold-campaign`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  if (res.data.status == "success") {
    return res.data;
  }
};

// Edit cold Campaign
export const edit_cold_campaign = async (data) => {
  const res = await axiosTuri.post(`edit-cold-campaign/${data.id}`, data.data);
  if (res.data.status == "success") {
    return res.data;
  }
};

// Delete Cold Campaign
export const delete_cold_campaign = async (id) => {
  const res = await axiosTuri.delete(`delete-cold-campaign/${id}`);
  if (res.data.status == "success") {
    return res.data;
  }
};
